import Modal from 'react-bootstrap/Modal';
import { Button, Form } from 'react-bootstrap';
import React from 'react';
import { useEffect, useState } from 'react';
import { Api } from './interface';
import { toast } from 'react-toastify';

export default function GeekStockTakeAdjust(props) {
  const [transaction, setTransaction] = useState(props.transaction);
  const [comment, setComment] = useState(null);

  useEffect(() => {
    setTransaction(props.transaction);
  }, [props.transaction]);

  const handleComments = (val) => {
    setComment(val);
  };

  const resolveTr = () => {
    Api({
      sp: 'resolveGeekStockAdjustment',
      json: {
        adjustmentId: transaction['Adjustment ID'],
        comment: comment,
      },
    }).then(() => {
      toast.success(
        transaction['Adjustment ID'] + ' is set to resolved status now'
      );
      props.closeModal(true);
    });
  };

  return (
    <Modal
      show={props.show}
      onHide={() => props.closeModal(true)}
      className="entity-modal"
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>Transaction Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Please make sure the transaction adjustment related changes are done in
        ELM before you move the transaction to Resolve status.
        <br />
        <br />
        <table className="table table-bordered">
          <tbody>
            <tr>
              <th>TransactionID</th>
              <td>{transaction['Adjustment ID']}</td>
            </tr>
            <tr>
              <th>BuildID</th>
              <td>{transaction['Build ID']}</td>
            </tr>
            <tr>
              <th>Quantity</th>

              <td>{transaction['Quantity']}</td>
            </tr>
          </tbody>
        </table>
        <div className="mb-2">
          <br />
          <br />
          <h6>Comments</h6>
          <Form.Control
            className="w-100 overflow-hidden"
            as="textarea"
            rows="1"
            placeholder="Type..."
            onChange={(e) => handleComments(e.target.value)}
            value={comment}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="confirm">
          <Button
            variant="outline-primary"
            onClick={() => props.closeModal(true)}
            className="footer-button"
          >
            Close
          </Button>
          <Button
            className="ms-2 footer-button"
            variant="success"
            onClick={() => {
              resolveTr();
            }}
          >
            Resolve
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
